const state = {
    confirmFlag: false,

}
const getters = {
    isConfirmShow(state) {
        return state.confirmFlag
    },
}
const mutations = {
    confirmDialogue(state, payload) {
        state.confirmFlag = payload;
    },
}
const actions = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}